import React, { useState, useMemo } from "react";
import {
  Chart as ChartJS,
  BarController,
  BarElement,
  LineController,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Register chart.js components
ChartJS.register(
  BarController,
  LineController,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const baseData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  datasets: [
    {
      type: "line",
      label: "Stock Trend",
      data: [5000, 5500, 6000, 6000, 5800, 8000],
      borderColor: "#FFBD26",
      borderWidth: 2,
      pointRadius: 0,
      fill: false,
      tension: 0.6,
      order: 0,
      yAxisID: "y",
    },
    {
      type: "bar",
      label: "Expenses",
      data: [6000, 7000, 7400, 7400, 8300, 8000],
      backgroundColor: Array(6).fill("#9FAFAF"),
      borderRadius: {
        topLeft: 4,
        topRight: 4,
        bottomLeft: 0,
        bottomRight: 0
      },
      borderSkipped: 'bottom', // This ensures the bottom border is visible
      order: 1,
      yAxisID: "y",
      barPercentage: 0.9,
      categoryPercentage: 0.8,
    },
    {
      type: "bar",
      label: "Revenue",
      data: [5000, 7000, 7800, 8200, 8700, 8000],
      backgroundColor: Array(6).fill("#CFD7D7"),
      borderRadius: {
        topLeft: 4,
        topRight: 4,
        bottomLeft: 0,
        bottomRight: 0
      },
      borderSkipped: 'bottom', // This ensures the bottom border is visible
      order: 2,
      yAxisID: "y",
      barPercentage: 0.9,
      categoryPercentage: 0.9,
    },
  ],
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { mode: "index", intersect: false },
  },
  scales: {
    y: {
      min: 1000,
      max: 10000,
      grid: { display: false },
      position: "left",
      ticks: {
        stepSize: 1000,
        font: { size: 6, weight: "bold" },
            padding: 2,
        color: "#000",
        callback: (value) => (value === 0 ? "" : value),
      },
      offset: true,
    },
    yRight: {
      min: 1000,
      max: 10000,
      position: "right",
      grid: { drawOnChartArea: false },
      ticks: {
        stepSize: 1000,
        font: { size: 6, weight: "bold" },
        color: "#000",
        padding: 2, 
        callback: (value) => (value === 0 ? "" : value),
      },
      offset: true,
    },
    x: {
      grid: { display: false },
      ticks: {
        font: { size: 10, weight: "bold" },
        color: "#000",
        
      },
    },
  },
  layout: {
    padding: { top: 8, bottom: 8 },
  },
};

const ChartComponent = () => {
  const [hoveredColor, setHoveredColor] = useState(null);

  const filteredData = useMemo(() => {
    return {
      ...baseData,
      datasets: baseData.datasets.map((dataset) => {
        if (dataset.type === "line") return dataset;

        return {
          ...dataset,
          backgroundColor: dataset.backgroundColor.map((color) =>
            !hoveredColor || color === hoveredColor
              ? color
              : "rgba(0,0,0,0.05)"
          ),
        };
      }),
    };
  }, [hoveredColor]);

  return (
    <div className="relative md:mt-1 md:px-5   px-4  w-full h-[250px] ">
 
      <div className="w-full h-[90%] z-10 ">
      
        <Chart type="bar" data={filteredData} options={options} />
      </div>

      {/* Color filter boxes */}
      <div className=" grid grid-cols-6  px-2 ">
        {/* Expenses */}
        
        <div className="flex flex-col gap-1">
    
          <div className="flex items-center space-x-1">
            <div
              className="w-[14px] h-[14px] bg-[#FFBD26]  rounded-full cursor-pointer"
              onMouseEnter={() => setHoveredColor("#FFBD26")}
              onMouseLeave={() => setHoveredColor(null)}
              title="Highlighted Expense"
            />
            <h1 className="text-[4px] font-normal text-[#152C24]">Farmers</h1>
          </div>
        </div>

        {/* Revenue */}
        <div className="flex flex-col gap-1">
        
          <div className="flex items-center space-x-1">
            <div
              className="w-[14px] h-[14px] bg-[#2E453D] rounded-full cursor-pointer"
              onMouseEnter={() => setHoveredColor("#2E453D")}
              onMouseLeave={() => setHoveredColor(null)}
              title="Highlighted Revenue"
            />
            <h1 className="text-[4px]  font-normal text-[#2E453D]">Land </h1>
          </div>
        </div>
        <div className="flex flex-col gap-1">
    
          <div className="flex items-center space-x-1">
            <div
              className="w-[14px] h-[14px] bg-[#9FAFAF] rounded-full  cursor-pointer"
              onMouseEnter={() => setHoveredColor("#9FAFAF")}
              onMouseLeave={() => setHoveredColor(null)}
              title="Highlighted Expense"
            />
            <h1 className="text-[4px] font-normal text-[#152C24]">Production cost</h1>
          </div>
        </div>
        <div className="flex flex-col gap-1">
    
    <div className="flex items-center space-x-1">
      <div
        className="w-[14px] h-[14px] bg-[#CFD7D7] rounded-full  cursor-pointer"
        onMouseEnter={() => setHoveredColor("#CFD7D7")}
        onMouseLeave={() => setHoveredColor(null)}
        title="Highlighted Expense"
      />
      <h1 className="text-[4px]  font-normal text-[#152C24]">Revenue</h1>
    </div>
  </div>
  <div className="flex flex-col gap-1">
    
    <div className="flex items-center space-x-1">
      <div
        className="w-[14px] h-[14px] bg-[#152C24] rounded-full  cursor-pointer"
        onMouseEnter={() => setHoveredColor("#152C24")}
        onMouseLeave={() => setHoveredColor(null)}
        title="Highlighted Expense"
      />
      <h1 className="text-[4px]  font-normal text-[#152C24]">Inventory</h1>
    </div>
  </div>
  <div className="flex flex-col gap-1">
    
    <div className="flex items-center space-x-1">
      <div
        className="w-[14px] h-[14px] bg-[#F23939] rounded-full  cursor-pointer"
        onMouseEnter={() => setHoveredColor("#F23939")}
        onMouseLeave={() => setHoveredColor(null)}
        title="Highlighted Expense"
      />
      <h1 className="text-[4px]  font-normal text-[#152C24]">Price</h1>
    </div>
  </div>
      </div>
    </div>
  );
};

export default ChartComponent;